import { TabsBarTab } from '@e3dc-react/shell/Elements/Tabs/TabsBar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useHeaderTabs } from '@e3dc-react/shell/Libs/Header'
import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { isFlowTheme } from 'src/Libs/utils'

interface UseUserTabs {
  tabs: TabsBarTab[]
  setTabs: (value: TabsBarTab[]) => void
  setActiveTab: (value: number) => void
}

/**
 * Get tab array for User Data pages
 * @returns Tabs for user overview
 */
export const useUserTabs = (): UseUserTabs => {
  const { setTabs, setActiveTab } = useHeaderTabs()
  const { t, selectedAppLanguage } = useCustomTranslation()
  const { id } = useParams<{ id: string }>()

  const tabs = useMemo(
    () => [
      {
        label: t('common.details'),
        href: `/overview/users/${id}`,
      },
      {
        label: t('service-dashboard.users.tabs.installations'),
        href: `/overview/users/${id}/installations`,
        disabled: isFlowTheme,
      },
    ],
    [selectedAppLanguage] // eslint-disable-line
  )

  useEffect(() => {
    setTabs(tabs)
    return () => {
      setTabs([])
    }
  }, [tabs, setTabs])

  return { tabs, setTabs, setActiveTab }
}
